// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1oS5L","list":"styles_list__1jlXg"};